/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Unscrambler for word games`)
};

const es_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descifrador de palabras para juegos de palabras`)
};

const de_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wortentwirrer für Wortspiele`)
};

const nl_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woorden Ontwarren voor woordspellen`)
};

const fr_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déchiffreur de mots pour les jeux de mots`)
};

const it_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca Parole per giochi di parole`)
};

const pt_br2_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desembaralhador de Palavras para jogos de palavras`)
};

const pt_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbaralhador de Palavras para jogos de palavras`)
};

const ja_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワードゲーム向け文字並べ替えツール`)
};

const zh_home_seo_wordunscrambler_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于文字游戏的字母重组工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_wordunscrambler_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_wordunscrambler_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_wordunscrambler_title", locale)
	if (locale === "en") return en_home_seo_wordunscrambler_title(inputs)
	if (locale === "es") return es_home_seo_wordunscrambler_title(inputs)
	if (locale === "de") return de_home_seo_wordunscrambler_title(inputs)
	if (locale === "nl") return nl_home_seo_wordunscrambler_title(inputs)
	if (locale === "fr") return fr_home_seo_wordunscrambler_title(inputs)
	if (locale === "it") return it_home_seo_wordunscrambler_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_wordunscrambler_title(inputs)
	if (locale === "pt") return pt_home_seo_wordunscrambler_title(inputs)
	if (locale === "ja") return ja_home_seo_wordunscrambler_title(inputs)
	return zh_home_seo_wordunscrambler_title(inputs)
};